import React from 'react';
import './App.css';
import ReactWhatsapp from "react-whatsapp";
import { ImWhatsapp } from 'react-icons/im';
import { FiInstagram } from 'react-icons/fi';
import { BsSnapchat } from 'react-icons/bs';
import { CiFacebook } from 'react-icons/ci';
import Logo from './Logos.png';

function App() {
  return (
    <div className="container">
      <h1 className="heading"> <img src={Logo} alt="Jovial Boutique Logo" className='Logo' /> </h1>
      <h2 className='description'> مرحبا بك في وجهتك لي التسوق من عاصمة الموضة باريس <br/> 
تابيعونا على وسائل التواصل الاجتماعي للاطلاع على العروض الحصرية <br/>
في جوڤيال نحن دائمًا هنا لمساعدتك في العثور على كل ما تحتاجينه لتكتمل اطلالتك الأنيقة والمميزة. لا تترددي في مراسلتنا عبر الواتساب او على بريد الصفحة 
 </h2>
      <ul className="links">
        <li><a href="https://www.facebook.com/profile.php?id=100089663356575" className='link' target="_blank"> <CiFacebook/> Facebook </a></li>
        <li> <div className='link'> <ReactWhatsapp number="+33613421469 "> <p className='whats'>
        <ImWhatsapp/> +33 613 42 14 69  </p> </ReactWhatsapp></div></li>
        <li><a href="https://www.instagram.com/Jovial.boutique/?fbclid=IwAR1KfLvNBVMp6d1H0XPC2UeS8arzyWsg7Rqe4ak1q1a1p2gl1Z5YtvRduRs"  target="_blank" className='link'><FiInstagram/> Instagram </a></li>
        <li><a href="https://www.snapchat.com/add/jovial.boutique"  target="_blank" className='link'> <BsSnapchat/> SnapChat </a></li>
      </ul>
    </div>
  );
}

export default App;
